import { render } from "./MyAccountRoomsPage.vue?vue&type=template&id=e80012f0&scoped=true"
import script from "./MyAccountRoomsPage.vue?vue&type=script&lang=js"
export * from "./MyAccountRoomsPage.vue?vue&type=script&lang=js"

import "./MyAccountRoomsPage.vue?vue&type=style&index=0&id=e80012f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80012f0"]])

export default __exports__